export default "__VITE_ASSET__18994c37__"